import script from "./PaginatedList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaginatedList.vue?vue&type=script&lang=ts&setup=true"

import "./PaginatedList.vue?vue&type=style&index=0&id=2f249287&lang=css"

const __exports__ = script;

export default __exports__